// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1Hwor","error":"Textarea_error__2ycKD","readonly":"Textarea_readonly___uWTh","disabled":"Textarea_disabled__vekcd"};